import * as React from 'react';

type Props = {
    children: React.ReactNode;
    predicate: boolean;
};

const Show = ({ children, predicate }: Props) =>
    predicate ? <>{children}</> : null;

export default Show;
